import { default as Wave } from './wave';
import { default as Spinner } from './spinner';
import { default as Loading } from './loading';
import { default as Circle } from './circle';

export { Wave, Spinner, Loading, Circle };